import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ICurrentUser, IPageConfiguration } from './user.interface';

export const EMPTY_ACTION = '[APP] Empty Action';

export const userActions = createActionGroup({
  events: {
    getCurrentUser: emptyProps(),
    getCurrentUserCompleted: props<{ user: ICurrentUser }>(),
    updateUserConfigurations: props<{ pageConfiguration: IPageConfiguration; omitSuccessToast?: boolean }>(),
    updateUserConfigurationsCompleted: props<{ omitSuccessToast?: boolean }>(),
  },
  source: 'User',
});
